/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    Int32IdAndLabel,
    Int32IdAndLabelFromJSON,
    Int32IdAndLabelFromJSONTyped,
    Int32IdAndLabelToJSON,
    ProviderCode,
    ProviderCodeFromJSON,
    ProviderCodeFromJSONTyped,
    ProviderCodeToJSON,
} from './';

/**
 * 
 * @export
 * @interface BookingDiagnosticsRequest
 */
export interface BookingDiagnosticsRequest {
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof BookingDiagnosticsRequest
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {Int32IdAndLabel}
     * @memberof BookingDiagnosticsRequest
     */
    channel?: Int32IdAndLabel;
    /**
     * 
     * @type {string}
     * @memberof BookingDiagnosticsRequest
     */
    salesJourney?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BookingDiagnosticsRequest
     */
    agency?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BookingDiagnosticsRequest
     */
    bookingRef?: string | null;
    /**
     * 
     * @type {ProviderCode}
     * @memberof BookingDiagnosticsRequest
     */
    providerCode?: ProviderCode;
}

export function BookingDiagnosticsRequestFromJSON(json: any): BookingDiagnosticsRequest {
    return BookingDiagnosticsRequestFromJSONTyped(json, false);
}

export function BookingDiagnosticsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BookingDiagnosticsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'channel': !exists(json, 'channel') ? undefined : Int32IdAndLabelFromJSON(json['channel']),
        'salesJourney': !exists(json, 'salesJourney') ? undefined : json['salesJourney'],
        'agency': !exists(json, 'agency') ? undefined : json['agency'],
        'bookingRef': !exists(json, 'bookingRef') ? undefined : json['bookingRef'],
        'providerCode': !exists(json, 'providerCode') ? undefined : ProviderCodeFromJSON(json['providerCode']),
    };
}

export function BookingDiagnosticsRequestToJSON(value?: BookingDiagnosticsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'channel': Int32IdAndLabelToJSON(value.channel),
        'salesJourney': value.salesJourney,
        'agency': value.agency,
        'bookingRef': value.bookingRef,
        'providerCode': ProviderCodeToJSON(value.providerCode),
    };
}


